import { ref } from 'vue'
import MobileDetect from 'mobile-detect'

export const useDevice = () => {
  const ua = navigator.userAgent.toLowerCase()
  const isMobile = ref(/mobi|android|iphone/i.test(ua))
  isMobile.value = window.innerWidth <= 768
  const isWeixin = ref(/micromessenger/i.test(ua))
  const isAndroid = ref(ua.indexOf('android') > -1 || ua.indexOf('adr') > -1)
  const isHarmony = ref(ua.indexOf('openharmony') > -1 || ua.indexOf('huawei') > -1)
  const isMoyuApp = ref(ua.includes('hero'))
  const isMac = ref(ua.includes('mac os'))

  // 修复 Safari 判断：排除 iOS 上的其他浏览器
  const isSafari = ref(
    ua.indexOf('safari') !== -1 &&
    ua.indexOf('chrome') === -1 &&
    ua.indexOf('crios') === -1 &&      // 排除 Chrome iOS
    ua.indexOf('fxios') === -1 &&      // 排除 Firefox iOS
    ua.indexOf('edgios') === -1 &&     // 排除 Edge iOS
    ua.indexOf('opios') === -1         // 排除 Opera iOS
  )

  const isChrome = ref(ua.indexOf('chrome') !== -1 && !/micromessenger/i.test(ua))
  const isChromeIos = ref(ua.indexOf('crios') !== -1)

  window.addEventListener('resize', () => {
    isMobile.value = window.innerWidth <= 768
  })

  const isIOS = () => {
    const { userAgent } = navigator
    const { platform } = navigator
    const maxTouchPoints = navigator.maxTouchPoints || 0

    // 判断 iPhone、iPod、iPad
    const iOSDevice = /iPhone|iPod|iPad/i.test(userAgent)

    // iPad 特定的判断，iOS 13+ 的 iPad 可能返回 MacIntel 作为 platform
    const isIpad = platform === 'MacIntel' && maxTouchPoints > 1

    return iOSDevice || isIpad
  }

  const md = new MobileDetect(ua)

  const isMobileReal = ref(!!(md.mobile() || md.tablet() || isIOS()))

  // PC/移动端  二维数组样式传入
  const getResponsiveStyles = (styleGroups: [string, string][]): string[] => {
    return styleGroups.map(([pcStyle, moStyle]) => (isMobileReal.value ? moStyle : pcStyle))
  }

  // 判断是否应该显示 Apple Pay
  const shouldShowApplePay = () => {
    console.log("isSafari", isSafari.value)
    console.log("isChromeIos", isChromeIos.value)
    console.log("isIOS", isIOS())

    // 移动端：安卓不显示，iOS 只有 Safari 才显示
    if (isMobile.value) {
      if (isAndroid.value) {
        return { showAdyen: false, showAirwallex: false };
      }
      if (isIOS()) {
        // iOS 上只有真正的 Safari 才显示 Adyen 的 Apple Pay
        return { showAdyen: isSafari.value, showAirwallex: true };
      }
    }

    // PC 端：只有 Safari 才显示
    return { showAdyen: isSafari.value, showAirwallex: true };
  };

  const filterPayTypeList = (list) => {
    const { showAdyen, showAirwallex } = shouldShowApplePay();

    return list.filter(p => {
      const isApplePay = p.sub_pay_type === 'applepay';

      if (!isApplePay) return true; // 非 Apple Pay，保留

      // ADYEN 的 Apple Pay
      if (p.pay_type_name === 'ADYEN') {
        return showAdyen;
      }

      // Airwallex 的 Apple Pay
      if (p.pay_type_name === 'AIRWALLEX') {
        return showAirwallex;
      }

      return true; // 其他情况保留
    });
  };

  return {
    isMobile,
    isWeixin,
    isAndroid,
    isMoyuApp,
    isMac,
    isMobileReal,
    isHarmony,
    isSafari,
    isChrome,
    isChromeIos,
    isIOS,
    getResponsiveStyles,
    filterPayTypeList
  }
}
